import { ClipLoader } from "react-spinners"
import { css } from "@emotion/react";
import styles from "../../services/styles";
import { useContext } from "react";
import GeneralContext from "../../context/GeneralContext/GeneralContext";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`
const { tc1, tc2, bc1, bc2, bc3 } = styles


export default function Loader (props){

    const {
        show_loading, setShowLoading,
    } = useContext(GeneralContext)


    return (
        show_loading
          ?
          <div>
            <div style={{ position: 'fixed', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9998, width: '100%', height: '100%', background: bc1, opacity: 0.5 }} />

            <div style={{ position: 'fixed', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, width: '100%', height: '100%' }}>
              <ClipLoader color={"#fff"} loading={show_loading} css={override} size={30} />
            </div>
          </div>
          :
          null
    )
}